import React, {Component} from 'react';
import PropTypes from 'prop-types';
import URLSearchParams from 'url-search-params';
import HorizontalScroll from '@homeaway/react-horizontal-scroll';

import {checkStatus} from '../../utils/api';
import BestMatchHit from './best-match-hit';
import './best-match.less';

class BestMatch extends Component {
    constructor(props) {
        super(props);

        /* Define state for the best match */
        this.state = {
            hits: []
        };

        this.validListingIdPattern = /^\d+\.\d+\.\d+$/;
    }

    /**
     *  componentDidMount()
     *  Add a listener for a resize event
     */
    componentDidMount() {
        if (typeof window !== 'undefined') {
            this.fetchApiHeart();
        }
    }

    componentDidCatch() {
        this.setState({hasError: true});
    }

    fetchApiHeart() {
        const {
            listingIds,
            searchTerm,
            startDate,
            endDate,
            useNewRecommendationService,
            logHaPulseRecoAbTestExposure,
            locale
        } = this.props;

        const urlQueryParams = new URLSearchParams();

        // start [SCRATCHPAD-1344] ha_pulse_reco_ab_test
        if (useNewRecommendationService) {
            urlQueryParams.set('recommendationModel', 'LISTING');
        }
        // end [SCRATCHPAD-1344] ha_pulse_reco_ab_test

        const listingId = listingIds[0];
        const isDated = !!(startDate && endDate);
        let recoDateRange = '';
        // [SCRATCHPAD-598] Sanity check listingId to avoid malformed requests
        if (!this.validListingIdPattern.test(listingId)) {
            return;
        }
        const exclusions = listingIds.slice(1);
        let numberOfRecos = 10;
        urlQueryParams.set('size', numberOfRecos);
        urlQueryParams.set('fallBack', numberOfRecos - 1);
        urlQueryParams.set('searchSort', 'mostPopular');
        urlQueryParams.set('listingId', listingId);
        urlQueryParams.set('locale', locale);
        if (exclusions.length > 0) {
            exclusions.forEach((exclusion) => {
                urlQueryParams.append('exclusions', exclusion);
            });
        }
        urlQueryParams.set('searchTerm', searchTerm);

        if (isDated) {
            urlQueryParams.set('startDate', startDate);
            urlQueryParams.set('endDate', endDate);

            let formattedStart = startDate.split('-');
            formattedStart.push(formattedStart.shift());
            formattedStart = formattedStart.join('%2f');

            let formattedEnd = endDate.split('-');
            formattedEnd.push(formattedEnd.shift());
            formattedEnd = formattedEnd.join('%2f');

            recoDateRange = `?arrivalDate=${formattedStart}&departureDate=${formattedEnd}`;
        }

        fetch(`/traveler/scratchpad/api/recent-activity/findByListing?${urlQueryParams.toString()}`)
            .then(checkStatus)
            .then((r) => r.json())
            .then((response) => {
                const responseHits = response.recommendedHits;
                const hits = responseHits ? responseHits.map((hit) => ({
                    averageRatingClass: hit.averageRatingClass,
                    bathrooms: hit.presentationModel.bathroomsMessage,
                    bedrooms: hit.presentationModel.bedroomsMessage,
                    detailPageUrl: `${hit.propertyHref}${recoDateRange}`,
                    isDated,
                    noPrice: hit.presentationModel.noPriceMessage,
                    rate: hit.rate,
                    ratesUnitOfMeasure: hit.rateUnitOfMeasure,
                    reviewCount: hit.reviewCount,
                    sleeps: hit.presentationModel.sleepsMessage,
                    thumbnailUrl1: hit.imageHref,
                    // don't gray out gallery
                    status: 'AVAILABLE'
                })) : [];

                this.setState({hits: hits.splice(0, numberOfRecos), message: response.bestMatchSearchText});

                // start [SCRATCHPAD-1344] ha_pulse_reco_ab_test
                if (hits.length > 1) { // only fire exposure when user is shown recommendations
                    logHaPulseRecoAbTestExposure();
                }
                // end [SCRATCHPAD-1344] ha_pulse_reco_ab_test
            });
    }

    render() {
        let message = null;

        if (this.state.hasError || this.state.hits.length === 0) {
            return null;
        }

        /* if there is a default message passed in as a prop, render it otherwise use the
        message retrieved from the fetch request */
        if (this.props.defaultMessage) {
            message = this.props.defaultMessage;
        } else {
            message = this.state.message;
        }

        return (
            <div>
                <div className="best-match-headline">{message}</div>
                <div className="best-match-container">
                    <HorizontalScroll {...this.props}>
                        {this.state.hits.map((hit, index) => (
                            <BestMatchHit key={`slide${index}`} hit={hit} index={index + 1} onClick={this.props.onClick} />
                        ))}
                    </HorizontalScroll>
                </div>
            </div>
        );
    }
}

BestMatch.propTypes = {
    defaultMessage: PropTypes.string,
    listingIds: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    scratchpadId: PropTypes.string.isRequired,
    searchTerm: PropTypes.string.isRequired,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    useNewRecommendationService: PropTypes.bool,
    logHaPulseRecoAbTestExposure: PropTypes.func
};

BestMatch.defaultProps = {
    useNewRecommendationService: false,
    logHaPulseRecoAbTestExposure: () => {}
};

export default BestMatch;



// WEBPACK FOOTER //
// ./src/universal/recent-activity/components/best-match.js